import { ActionsUnion, createAction } from '@housinganywhere/safe-redux';
import { Thunk } from 'ha/myredux/types';

import { RootState } from './types';
import { getPlayedExperiments } from './selectors';
import getSelectedVariant, { Experiment } from './utils/getSelectedVariant';

export enum ActionTypes {
  SET_VARIANTS = `EXPERIMENTS/SET_VARIANTS`,
  PLAY_EXPERIMENT = `EXPERIMENTS/PLAY_EXPERIMENT`,
}

export const Actions = {
  setVariants: (
    variants: { [name: string]: string },
    userIdentifier?: string,
  ) =>
    createAction(ActionTypes.SET_VARIANTS, {
      variants,
      userIdentifier,
    }),
  play: (name: string, variant: string, userIdentifier?: string) =>
    createAction(ActionTypes.PLAY_EXPERIMENT, name, {
      analytics: {
        type: '$experiment_started',
        payload: {
          'Experiment name': name,
          'Variant name': variant,
          nonInteraction: 1,
          ha_anonymous_id: userIdentifier,
        },
      },
    }),
};

export type Actions = ActionsUnion<typeof Actions>;

interface InitExperiments {
  experiments: { [name: string]: Experiment };
  userIdentifier?: string;
}

export const initExperiments = ({
  experiments,
  userIdentifier,
}: InitExperiments): Thunk => dispatch => {
  const variants = Object.keys(experiments).reduce(
    (acc, experiment) => ({
      ...acc,
      [experiments[experiment].name]: getSelectedVariant(
        experiments[experiment],
        userIdentifier,
      ),
    }),
    {},
  );

  dispatch(Actions.setVariants(variants, userIdentifier));
};

export const playExperiment = (
  name: string,
  variant: string,
  userIdentifier?: string,
): Thunk<RootState> => (dispatch, getState) => {
  if (!getPlayedExperiments(getState()).includes(name)) {
    dispatch(Actions.play(name, variant, userIdentifier));
  }
};

export const { setVariants } = Actions;
